import { createStore } from 'vuex'
import { getUrlParams } from "@/hooks/getUrlParams"

const getStorage = function(value:any){
    let data 
    try {
        data = JSON.parse(localStorage.getItem(value) || '')
    } catch (error) {
        data = localStorage.getItem(value)
    }
    return data
}
const setStorage = function(key:string,data:any){
    if(data instanceof Object){
        localStorage.setItem(key,JSON.stringify(data))
    }else{
        localStorage.setItem(key,data)
    }
    return data
}

export default createStore({
    state: {
        signInfo: {
            company_id: getUrlParams("company_id"),
            contract_type: getUrlParams("contract_type"),
            // company_id: "2",
            // contract_type: "3",
            // task_id: 1,
            // name: '方银浩',
            // id_card: '42070419971102167X',
            // front_url: 'https://qiniu.hnfylhfreelancer.top/1756804242142_341753329738_.pic_hd.jpg',
            // back_url: 'https://qiniu.hnfylhfreelancer.top/1756804253394_351753329739_.pic_hd.jpg',
            // phone: '18107114013',
            // account: '18107114013',
            // bank_name: "支付宝"
        },
        pageConfig: getStorage('pageConfig') || {}
    },
    getters: {
        getStepOne({signInfo}){
            const { name, id_card, front_url, back_url }: any = signInfo
            return {
                name,
                id_card,
                front_url,
                back_url
            }
        },
        getStepTwo({signInfo}){
            const { account, bank_name, phone }: any = signInfo
            return {
                account,
                bank_name,
                phone
            }
        },
        getPageConfig: state => {
            return state.pageConfig
        }
    },
    mutations: {
        CHANGE_INFO:(state,obj) => {
            Object.assign(state.signInfo,obj)
        },
        RESET_STATE:(state) => {
            (state as any).signInfo = {}
        },
        SET_PAGE_CONFIG: (state, params) => {
            state.pageConfig = params
            setStorage('pageConfig',params)
            document.title = state.pageConfig.title || "安心付"
            const title_icon:any = document.querySelector('link[rel="icon"]')
            if(title_icon){
                title_icon.href = state.pageConfig.icon
            }
        }
        
    },
    actions: {
        changeInfo({commit},data){
            return new Promise((resolve) => {
                commit('CHANGE_INFO',data)
                resolve('OK')
            })
        }    
    },
    modules: {
    }
})
